import {createStore} from "effector";

export const $viewModalState = createStore({visible: false, id: null, type: ''})